import { render } from "./ControleCobrancasGarantePayView.vue?vue&type=template&id=a8ad8222&scoped=true"
import script from "./ControleCobrancasGarantePayView.vue?vue&type=script&lang=js"
export * from "./ControleCobrancasGarantePayView.vue?vue&type=script&lang=js"

import "./ControleCobrancasGarantePayView.vue?vue&type=style&index=0&id=a8ad8222&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ad8222"]])

export default __exports__